export enum EProcessNames {
  GERAR_CONTRATO = "gerar_contrato",
  EDITAR_CONTRATO = "editar_contrato",
  EXCLUIR_CONTRATO = "excluir_contrato",
  GERAR_ADITIVO = "gerar_aditivo",
  GERAR_DISTRATO = "gerar_distrato",
  ANEXAR_ARQUIVOS = "anexar_arquivos",
  GERAR_MEDICOES = "gerar_medicoes",
  APROVAR_MEDICOES = "aprovar_medicoes",
  EXCLUIR_MEDICOES = "excluir_medicoes",
  CRIAR_DOC_VENDA = "criar_documento_de_venda",
  INDICADORES = "indicadores",
}
